import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import Toasted from "vue-toasted";
import VTooltip from "v-tooltip";
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false;

Vue.use(Toasted, {
  action: {
    text: "X",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
  position: "top-center",
  duration: 3000,
  keepOnHover: true,
});

Vue.use(VTooltip);

Vue.use(VueGtag, {
  config: { id: "G-MS2P0YNH9S" }
});

Vue.filter("stripHTML", function(value) {
  const div = document.createElement("div");
  div.innerHTML = value;
  const text = div.textContent || div.innerText || "";
  return text;
});

store.dispatch('keycloak/initKeycloak');

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
